import React from 'react';
import Navbar from '../../../components/Navbar';
import CreateVerificationForm from '../../../components/VerificationForms/CreateVerificationForm';
import { useQuery } from '@apollo/client';
import { getAssetByAssetNumber, getAssetByBarcode } from '../api';
import { Loader } from '../../../components/Loader';

export const CreateVerificationPage = (props) => {
  let keyType = props.match.params.type;
  const urlData = JSON.parse(decodeURIComponent(props.match.params.key));
  const queryVariables = () => {
    if (keyType === 'a') {
      return {
        assetNumber: urlData.assetNumber,
      };
    }
    return {
      barcode: urlData.barcode,
    };
  };

  const { loading, error, data } = useQuery(keyType === 'a' ? getAssetByAssetNumber : getAssetByBarcode, {
    variables: queryVariables(),
  });

  if (loading)
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );

  if (error) return <div>error</div>;

  if (data)
    return (
      <div>
        <Navbar />
        <CreateVerificationForm data={data} />
      </div>
    );
};
